import { createActionGroup, emptyProps, props } from '@ngrx/store'

export const AiIntegratorActions = createActionGroup({
  source: 'AiIntegrator',
  events: {
    // Data source generation
    generateDatasource: props<{ prompt: string; openapiUrl?: string }>(),
    getAnswerEventStream: props<{ response: any }>(),
    generateDatasourceSuccess: props<{ system: any }>(),
    generateDatasourceFailure: props<{ error: any }>(),

    // Edit existing data source
    editDatasource: props<{ prompt: string; currentSystem: any }>(),
    keepEditedDatasourceDraft: emptyProps(),
    keepEditedDatasourceDraftSuccess: props<{ response: any }>(),

    // Keep / Discard
    keepDatasourceDraft: emptyProps(),
    keepDatasourceDraftSuccess: props<{ response: any }>(),
    keepDatasourceDraftFailure: emptyProps(),
    discardDatasourceDraft: emptyProps(),

    // Legacy agent support
    keepAgentDraft: emptyProps(),
    keepAgentDraftSuccess: props<{ response: any }>(),
    keepAgentDraftFailure: emptyProps(),
  },
})
